.smallOnly {
    @media (min-width: 501px) {
        display: none;
    }
}

.mediumOnly {
    @media (max-width: 500px) {
        display: none;
    }

    @media (min-width: 769px) {
        display: none;
    }
}

.mediumAndSmaller {
    @media (min-width: 769px) {
        display: none;
    }
}

.mediumAndLarger {
    @media (max-width: 501px) {
        display: none;
    }
}

.largeOnly {
    @media (max-width: 768px) {
        display: none;
    }
}
